// Library methods

// Utils
import { GET, POST } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_FETCH_PAY_DATA,
    API_CREATE_PAY_LINK,
    API_UPDATE_PAY_LINK,
    API_SHARE_PAY_LINK,
    API_LIST_PAY_TRANSACTIONS,
    API_PAY_LINK_SUMMARY,
    API_RESHARE_PAY_LINK,
    API_MERCHANT_TEMPLATE_DETAILS, API_GENERATE_REPORT,
} from '../../../utils/API/apiUrls';

// Constant
import { SUCCESS_MESSAGES } from '../../../utils/constants/toastMessages';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as paymentLinkActions from './paymentLink.actions';

// Constants
import {
    FETCH_PAYMENT_LINK_REQUEST,
    FETCH_TRANSACTION_PAYMENT_REQUEST,
    CREATE_PAY_LINK_REQUEST,
    UPDATE_PAY_LINK_REQUEST,
    SHARE_PAY_LINK_REQUEST,
    RE_SHARE_PAY_LINK_REQUEST,
    VIEW_PAY_LINK_REQUEST,
    FETCH_MERCHANT_TEMPLATE_REQUEST,
    GENERATE_REPORT_REQUEST,
} from './paymentLink.constants';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { toast } from 'react-toastify';
import { takeLatest, put, call } from 'redux-saga/effects';
import * as transactionsActions from '../../Transactions/redux/transactions.actions';

// Format Payment link table filter and Request params.
const getRequestData = payload => {
    const filter = {};
    const request = {
        paginationDetails: {
            pageNo: payload.pageIndex || 1,
            pageSize: payload.pageSize || 10,
        },
    };
    if (payload.createdOn) {
        filter.startDate = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        filter.endDate = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }
    if (payload.linkName) {
        filter.linkName = payload.linkName;
    }
    if (payload.linkId) {
        const { linkId } = payload;
        filter.linkId = linkId;
    }
    if (payload.status) {
        const { status } = payload;
        filter.linkDataStatus = status;
    }
    if (filter && !isEmpty(filter)) {
        request.filter = filter;
    }

    return request;
};

// Format Transaction View Payment link filter and Request params.
const getRequestDataTrxn = payload => {
    const filter = {};
    const request = {
        paginationDetails: {
            pageNo: payload.pageIndex || 1,
            pageSize: payload.pageSize || 10,
        },
    };
    if (payload.linkDataId) {
        request.linkDataId = payload.linkDataId;
    }
    if (payload.createdOn) {
        filter.startDate = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        filter.endDate = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }
    if (payload.communicationModeValue) {
        filter.communicationModeValue = payload.communicationModeValue;
    }
    if (payload.transactionId) {
        filter.transactionId = payload.transactionId;
    }
    if (payload.transactionStatus) {
        const { transactionStatus } = payload;
        filter.transactionStatus = transactionStatus;
    }
    if (filter && !isEmpty(filter)) {
        request.filter = filter;
    }
    return request;
};

// Get details for the Payment link list for table.
export function* fetchPaymentLinkDetails(actions) {
    yield put(paymentLinkActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestData(payload);
        const { data } = yield call(POST, API_FETCH_PAY_DATA, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(paymentLinkActions.fetchPaymentLinkSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.fetchPaymentLinkError({
                    error: data,
                })
            );
        }
    } catch (error) {
        const data = error.response;
        yield put(
            paymentLinkActions.fetchPaymentLinkError({
                error: data,
            })
        );
    }
    yield put(paymentLinkActions.hideLoader());
}

// Get Details for the payment link transaction view.
export function* fetchPaymentsDetails(actions) {
    yield put(paymentLinkActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestDataTrxn(payload);
        const { data } = yield call(POST, API_LIST_PAY_TRANSACTIONS, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(paymentLinkActions.fetchPaymentsSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.fetchPaymentsError({
                    error: data,
                })
            );
        }
    } catch (error) {
        const { data } = error.response;
        yield put(
            paymentLinkActions.fetchPaymentsError({
                error: data,
            })
        );
    }
    yield put(paymentLinkActions.hideLoader());
}

// Create new payment link Saga function
export function* createPayLinkDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_CREATE_PAY_LINK, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(paymentLinkActions.createPayLinksSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.createPayLinksError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentLinkActions.createPayLinksError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

// Update the payment link Saga function
export function* updatePayLinkDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_UPDATE_PAY_LINK, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(paymentLinkActions.updatePayLinksSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.updatePayLinksError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentLinkActions.updatePayLinksError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

// Share the payment link Saga function
export function* sharePayLinkDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_SHARE_PAY_LINK, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(paymentLinkActions.sharePayLinksSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.sharePayLinksError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentLinkActions.sharePayLinksError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

// View the payment link summary Saga function
export function* viewPayLinkDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_PAY_LINK_SUMMARY, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(paymentLinkActions.viewPayLinksSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.viewPayLinksError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentLinkActions.viewPayLinksError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

// Re Share the payment link Saga function
export function* reSharePayLinkDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_RESHARE_PAY_LINK, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(paymentLinkActions.reSharePayLinksSuccess(data));
            toast.info(SUCCESS_MESSAGES.SHARED_DATA('Payment Link'));
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.reSharePayLinksError({
                    error: data,
                })
            );
            if (data && data.errorMessage) {
                toast.info(data.errorMessage);
            }
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentLinkActions.reSharePayLinksError({
                error: data,
            })
        );
        if (data && data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

// fetch mandate template Request
export function* fetchMandateTemplateRequest(actions) {
    yield put(loaderActions.showLoader());

    try {
        const { data } = yield call(GET, API_MERCHANT_TEMPLATE_DETAILS);

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            let successData = {
                template: { ...data },
            };

            yield put(
                paymentLinkActions.fetchMerchantTemplateSuccess({
                    ...successData,
                })
            );
        } else if (data && data.errorMessage) {
            yield put(
                paymentLinkActions.fetchMerchantTemplateError({
                    error: data,
                })
            );
            if (data && data.errorMessage) {
                toast.info(data.errorMessage);
            }
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            paymentLinkActions.fetchMerchantTemplateError({
                error: data,
            })
        );
        if (data && data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

const getRequestDataFile = payload => {
    const request = {};
    if (payload.createdOn) {
        request.startDateTime = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }
    if (payload.reportFileName) {
        request.reportFileName = payload.reportFileName;
    }
    if(payload.linkName){
        request.linkName = payload.linkName;
    }
    if(payload.linkId){
        request.linkId = payload.linkId;
    }
    if(payload.status){
        request.status = payload.status;
    }
    if(payload.status){
        request.status = payload.status;
    }

    request.reportType = 'PAYMENT_LINK';

    return request;
};


export function* generateTransactionReport(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const handleViewDownloads = payload.handleViewDownloads;
        delete payload.handleViewDownloads;

        let request = getRequestDataFile(payload);

        const { data } = yield call(POST, API_GENERATE_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(transactionsActions.generateReportSuccess(data));
            handleViewDownloads();
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage || '';
            yield put(
                transactionsActions.generateReportError({
                    error: errorMessage || '',
                })
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage || '';
        yield put(
            transactionsActions.generateReportError({
                error: errorMessage || '',
            })
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}


/**
 * WATCHER SAGA
 */
export function* paymentLinkSaga() {
    yield takeLatest(FETCH_PAYMENT_LINK_REQUEST, fetchPaymentLinkDetails);
    yield takeLatest(FETCH_TRANSACTION_PAYMENT_REQUEST, fetchPaymentsDetails);
    yield takeLatest(CREATE_PAY_LINK_REQUEST, createPayLinkDetails);
    yield takeLatest(UPDATE_PAY_LINK_REQUEST, updatePayLinkDetails);
    yield takeLatest(SHARE_PAY_LINK_REQUEST, sharePayLinkDetails);
    yield takeLatest(VIEW_PAY_LINK_REQUEST, viewPayLinkDetails);
    yield takeLatest(RE_SHARE_PAY_LINK_REQUEST, reSharePayLinkDetails);
    yield takeLatest(GENERATE_REPORT_REQUEST, generateTransactionReport);
    yield takeLatest(
        FETCH_MERCHANT_TEMPLATE_REQUEST,
        fetchMandateTemplateRequest
    );
}
